/* Dark-band parallax layer.
 *
 * Writes `transform` straight to the node on a passive scroll listener rather than going
 * through any component state, so it never queues work on the main thread beyond a single
 * style write. Travel is 13% of the band's height, from the design's motion table.
 *
 * Disabled below 900px and under `prefers-reduced-motion`, where the layer is reset to
 * `transform: none` rather than left wherever the last frame put it.
 *
 * The theme editor re-renders a section's DOM without re-executing `<script src>`, so the
 * band/layer pairs are collected again on `shopify:section:load` — otherwise editing any
 * setting on the dark band froze its discs for the rest of the session. The window
 * listeners are registered once and reused, so a re-render never stacks a second one.
 */
(function () {
  'use strict';

  if (window.dpParallaxLoaded) return;
  window.dpParallaxLoaded = true;

  var TRAVEL = 0.13;
  var BREAKPOINT = 900;

  var reducedQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  var pairs = [];
  var frame = null;

  function paint() {
    frame = null;
    if (!pairs.length) return;

    var off = (reducedQuery && reducedQuery.matches) || window.innerWidth < BREAKPOINT;

    pairs.forEach(function (pair) {
      if (off) {
        pair.layer.style.transform = 'none';
        return;
      }
      var rect = pair.band.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      var y = progress * TRAVEL * rect.height - rect.height * (TRAVEL / 2);
      pair.layer.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  }

  function schedule() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(paint);
  }

  function collect() {
    pairs = [];

    var bands = document.querySelectorAll('[data-dp-parallax-band]');
    Array.prototype.forEach.call(bands, function (band) {
      var layer = band.querySelector('[data-dp-parallax-layer]');
      if (layer) pairs.push({ band: band, layer: layer });
    });

    paint();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (reducedQuery && reducedQuery.addEventListener) {
    reducedQuery.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }

  document.addEventListener('shopify:section:load', collect);
})();
